import { OPTIMIZELY_FEATURE_FLAGS_KEYS, SCHEDULE_CALENDAR_V2 } from 'components/Optimizely/Optimizely.features';

import { useIsFeatureEnabled } from './useIsFeatureEnabled';

const VENUE_ATTRIBUTE = 'active_venue_id';

export function useIsScheduleCalendarV2Enabled(venueId) {
  return useIsFeatureEnabled(OPTIMIZELY_FEATURE_FLAGS_KEYS[SCHEDULE_CALENDAR_V2], { [VENUE_ATTRIBUTE]: venueId });
}
